import React from 'react';
import isEqual from 'fast-deep-equal';
import api from '../../services/api';
import ConfirmationBackdrop from '../CommonComponents/ConfirmationBackdrop';
import { validateEmail } from '../../utils/helpers';
class PdpEmail extends React.Component {
    constructor(props) {
        super(props);
        this.isNumeric = (n) => !Number.isNaN(Number(n)) && Number.isFinite(Number(n));
        this.clearErrors = () => {
            const { email, quantity, userLocation } = document.forms.namedItem('request_plant');
            userLocation.classList.remove('input-invalid');
            quantity.classList.remove('input-invalid');
            email.classList.remove('input-invalid');
            document.getElementById('email-feedback').innerHTML = '';
            document.getElementById('user_location-feedback').innerHTML = '';
            document.getElementById('quantity-feedback').innerHTML = '';
        };
        this.clearForm = () => {
            this.setState({
                comment: '',
                quantity: 1,
                location: 'United States',
                email: '',
            });
        };
        this.submitForm = (e) => {
            e.preventDefault();
            const { newsletterOptIn } = this.state;
            const hasHtml5Validation = typeof document.createElement('input').checkValidity === 'function';
            if (hasHtml5Validation) {
                const { email, quantity, userLocation } = document.forms.namedItem('request_plant');
                if (email.value === '') {
                    email.classList.add('input-invalid');
                    document.getElementById('email-feedback').innerHTML = 'Email is required';
                }
                else if (!validateEmail(email.value)) {
                    email.classList.add('input-invalid');
                    document.getElementById('email-feedback').innerHTML = 'Email is invalid';
                }
                else if (quantity.value === '' || Number(quantity.value) <= 0) {
                    quantity.classList.add('input-invalid');
                    document.getElementById('quantity-feedback').innerHTML = 'Quantity is required';
                }
                else if (!this.isNumeric(parseInt(quantity.value, 10))) {
                    quantity.classList.add('input-invalid');
                    document.getElementById('quantity-feedback').innerHTML = 'Please enter a number';
                }
                else if (userLocation.value === '') {
                    userLocation.classList.add('input-invalid');
                    document.getElementById('user_location-feedback').innerHTML = 'User Location is required';
                }
                else {
                    this.clearErrors();
                    this.setState({
                        loadButton: true,
                    });
                    if (newsletterOptIn) {
                        const data = {
                            email: email.value,
                            status: 'subscribed',
                        };
                        api.newsLetter.subscribe(data).then((res) => {
                            if (res.success
                                || (!res.success && res.message === 'Member Exists')) {
                                this.setState({
                                    userSubscribed: true,
                                });
                            }
                        });
                    }
                    api.plant
                        .requestPlants(new FormData(e.target))
                        .then(() => {
                        this.setState({
                            loadButton: false,
                            confirmOpen: true,
                        });
                    })
                        .catch(() => {
                        this.setState({
                            loadButton: false,
                            submitError: true,
                        });
                    });
                    this.clearForm();
                }
            }
        };
        this.updateInput = (e, val) => {
            e.preventDefault();
            const { newsletterOptIn } = this.state;
            const newState = { ...this.state };
            e.target.classList.remove('input-invalid');
            if (document.getElementById(`${e.target.name}-feedback`)) {
                document.getElementById(`${e.target.name}-feedback`).innerHTML = '';
            }
            newState[val] = val === 'newsletterOptIn' ? !newsletterOptIn : e.target.value;
            this.setState(newState);
        };
        this.closeModal = (e) => {
            e.preventDefault();
            const { closeModal } = this.props;
            this.setState({
                confirmOpen: false,
            });
            if (closeModal) {
                closeModal();
            }
        };
        this.confirmModal = () => {
            const { confirmOpen, userSubscribed } = this.state;
            const { plantName } = this.props;
            const mainMessage = 'Your Message Was Sent!';
            const secondMessages = [`We'll contact you if we locate a source for ${plantName}.`, userSubscribed && 'You are now subscribed to the Plantlust newsletter.'];
            if (confirmOpen) {
                return (React.createElement(ConfirmationBackdrop, { open: confirmOpen, mainMessage: mainMessage, secondMessages: secondMessages, close: this.closeModal }));
            }
            return null;
        };
        this.updateQuantity = (e, sign) => {
            e.preventDefault();
            let { quantity } = this.state;
            switch (sign) {
                case 'plus':
                    quantity += 1;
                    this.setState({
                        quantity,
                    });
                    break;
                case 'minus':
                    quantity -= 1;
                    this.setState({
                        quantity,
                    });
                    break;
                default:
                    break;
            }
        };
        this.state = {
            comment: '',
            quantity: 1,
            location: 'United States',
            email: '',
            newsletterOptIn: true,
            confirmOpen: false,
            loadButton: false,
            userSubscribed: false,
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        if (isEqual(this.state, nextState)
            && isEqual(this.props, nextProps)) {
            return false;
        }
        return true;
    }
    render() {
        const { plantId, plantName, isNotifyModal = false } = this.props;
        const { loadButton, quantity, email, location, comment, submitError, newsletterOptIn, } = this.state;
        return (React.createElement("div", { className: "pdp_email" },
            React.createElement("form", { name: "request_plant", method: "POST", onSubmit: this.submitForm },
                React.createElement("input", { type: "hidden", name: "plant_id", value: plantId, readOnly: true }),
                React.createElement("input", { type: "hidden", name: "plant_name", value: plantName, readOnly: true }),
                !isNotifyModal && (React.createElement("h2", null,
                    "Special request for",
                    ' ',
                    plantName)),
                React.createElement("p", { className: "subtitle" },
                    "We'll notify you if we locate",
                    ' ',
                    plantName,
                    ' ',
                    "and are able to ship to your area."),
                React.createElement("div", { className: "row email" },
                    React.createElement("label", { htmlFor: "email" },
                        "YOUR E-MAIL",
                        React.createElement("input", { type: "text", id: "email", name: "email", onChange: (e) => {
                                this.updateInput(e, 'email');
                            }, value: email, maxLength: 255 })),
                    React.createElement("label", { htmlFor: "email", id: "email-feedback", className: "feedback" })),
                React.createElement("div", { className: "row quantity" },
                    React.createElement("label", { htmlFor: "quantity" },
                        "QUANTITY WANTED",
                        React.createElement("input", { type: "number", id: "quantity", name: "quantity", value: quantity, min: 1, onChange: (e) => this.updateInput(e, 'quantity'), maxLength: 8 }),
                        React.createElement("div", { className: "plus_minus" },
                            React.createElement("input", { type: "image", src: `${process.env.STATIC_PATH}/img/photo_plus@2x.png`, alt: "plus", className: "plus", onClick: (e) => this.updateQuantity(e, 'plus') }),
                            React.createElement("input", { type: "image", src: `${process.env.STATIC_PATH}/img/photo_minus@2x.png`, alt: "minus", className: "plus", onClick: (e) => this.updateQuantity(e, 'minus') }))),
                    React.createElement("label", { id: "quantity-feedback", className: "feedback" })),
                React.createElement("div", { className: "row location" },
                    React.createElement("label", { htmlFor: "location" },
                        "YOUR LOCATION",
                        React.createElement("input", { type: "text", id: "location", name: "userLocation", value: location, maxLength: 128, onChange: (e) => this.updateInput(e, 'location') })),
                    React.createElement("label", { id: "user_location-feedback", className: "feedback" })),
                React.createElement("div", { className: "row comments" },
                    React.createElement("label", { htmlFor: "comments" },
                        "COMMENTS (OPTIONAL)",
                        React.createElement("textarea", { name: "comments", id: "comments", value: comment, maxLength: 4096, onChange: (e) => this.updateInput(e, 'comment') }))),
                React.createElement("div", { className: "row newsletter" },
                    React.createElement("input", { type: "checkbox", id: "newsletter", className: newsletterOptIn ? 'pdp_checked' : 'pdp_unchecked', name: "newsletter_optIn", checked: newsletterOptIn, onChange: () => { }, onClick: (e) => this.updateInput(e, 'newsletterOptIn') }),
                    React.createElement("label", { htmlFor: "newsletter" },
                        "Join the Mailing List",
                        ' ',
                        React.createElement("span", null,
                            "Pssst... get the scoop on new plant arrivals and deals",
                            ' ',
                            React.createElement("a", { target: "_blank", rel: "noopener noreferrer", href: "https://plantlust.com/blog/privacy-policy/" }, "Privacy Policy")))),
                submitError && (React.createElement("p", { className: "feedback" }, "Something went wrong. Please try again.")),
                React.createElement("div", { className: "row submit" }, loadButton ? (React.createElement("button", { className: "btn primary loading", type: "submit" }, "Send")) : (React.createElement("button", { className: "btn primary", type: "submit", id: "submit_form" }, "Send")))),
            this.confirmModal()));
    }
}
export default PdpEmail;
